<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Trhové ceny - OKTE (Celkové výsledky DT)</h2>
      </div>
      <div class="form-inline">
        <label class="mr-1">Dátum:</label>
        <single-date-picker
          :value="date"
          :disabled-dates="{
            from: $moment().subtract(1, 'day').toDate(),
          }"
          @input="changeDate"
        />
      </div>
      <b-btn class="ml-1" variant="secondary" disabled @click="exportPower">
        <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
        Exportovať
      </b-btn>
    </div>
    <div class="h-100" style="min-height: 1px">
      <b-overlay class="h-100" :show="loading" :blur="null" opacity="0">
        <transition name="fadeDownShort" mode="out-in">
          <div v-if="!loading" v-bar class="bar-out">
            <div>
              <b-row class="my-2">
                <b-col md="8">
                  <Chart :data="chartData" />
                </b-col>
                <b-col md="4">
                  <client-table
                    table-class="table-sm"
                    :data="data"
                    :columns="table.columns"
                    :sort-by.sync="table.sortBy"
                    :searchable="false"
                    striped
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </transition>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
import moment from 'moment'
import energyMarketService from '@/services/api/energyMarketService.js'
import Chart from './Chart.vue'
import SingleDatePicker from '@/components/inputs/SingleDatePicker'
import ClientTable from '@/components/ClientTable'
import { map } from 'lodash'

export default {
  components: { Chart, SingleDatePicker, ClientTable },
  data() {
    return {
      loading: false,
      data: [],
      date: moment().subtract(1, 'day').format('YYYY-MM-DD'),
      table: {
        columns: [
          {
            key: 'period',
            label: 'Perióda',
            class: 'text-right',
            sortable: true,
          },
          {
            key: 'price',
            label: 'Cena (€/MWh)',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
        ],
        sortBy: 'period',
      },
    }
  },
  computed: {
    chartData() {
      return map(this.data, (i) => {
        return {
          x: i.period,
          y: i.price,
        }
      })
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    changeDate(date) {
      this.date = date
      this.fetchData(true)
    },
    fetchData(silent = false) {
      this.loading = !silent
      energyMarketService
        .getOkteData({
          date: { ge: this.date, le: this.date },
        })
        .then((res) => {
          this.data = res.data[0].data
          if (!silent) {
            this.loading = false
          }
        })
    },
    exportPower() {
      /*energyMarketService
        .downloadExcelExport({
          tradeDateFrom: this.date,
          tradeDateTo: this.date,
        })
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })*/
    },
  },
}
</script>
